import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズの Products ロゴアイコン
 */
export function ProductLogoSmallProducts({
  size = 20,
  color = '#FF005A',
  ...props
}: ProductLogoSmallProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 480 480" fill="none" {...props}>
      <path d="M59.9971 160.877C59.9971 156.891 63.979 154.133 67.7109 155.534L214.904 210.772C220.844 213.001 224.778 218.679 224.778 225.023V412.113C224.778 416.099 220.796 418.857 217.064 417.456L79.7441 365.924C67.8655 361.466 59.9971 350.109 59.9971 337.421V160.877Z" fill={color} />
      <path d="M412.286 155.534C416.018 154.133 420 156.891 420 160.877V337.421C420 350.109 412.131 361.466 400.252 365.924L262.933 417.456C259.201 418.857 255.219 416.099 255.219 412.113V225.023C255.219 218.679 259.153 213.001 265.093 210.772L412.286 155.534Z" fill={color} />
      <path d="M229.3 65.6127C236.196 63.0248 243.797 63.0248 250.693 65.6127L395.48 119.949C400.417 121.802 400.417 128.784 395.48 130.637L245.345 186.979C241.897 188.273 238.096 188.273 234.648 186.979L84.5127 130.637C79.5763 128.784 79.5765 121.802 84.5127 119.949L229.3 65.6127Z" fill={color} />
    </svg>;
}